export const DESIGN_SYSTEMS = {
  GRAVITY: 'gravity',
  SOLAR_SYSTEM: 'solarSystem',
}

export const ACTIONS = {
  CTA: 'cta',
  ERROR: 'error',
}
